import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { CSSPlugin } from 'gsap/CSSPlugin'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		tabbedSlider()
		partnerCarousel()
		animateBodyUniqueContent()
		animateBasicLinks()
		animateContentColumns()
		animateRedContentBlock()
		animatePartnershipGrid()
		toggleGridModal()
		handleAccordion()
		handleAccordionCard()
		handleFAQs()

		window.addEventListener('load', () => {})

		if ($body.hasClass('home')) {
		} else if ($body.hasClass('private-equity')) {
		} else if ($body.hasClass('single-case-studies')) {
			$('.case-studies-back-button').on('click', (e) => {
				history.back()
			})
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function tabbedSlider() {
	const sliders = document.querySelectorAll('.theme-tabbed-slider--wrap')
	if (!sliders) {
		return
	}
	$('.theme-tabbed-slider--wrap').slick({
		dots: true,
		slidesToShow: 1,
		adaptiveHeight: true, //for retail page; QA request from Design Team
		autoplay: false,
		speed: 300,
		arrows: false,
		customPaging(slider, i) {
			let tab = $(slider.$slides[i]).data('tab')
			return tab
		},
	})

	const menus = document.querySelectorAll(
		'.theme-tabbed-slider--container .slick-dots'
	)

	menus.forEach(function (el, _idx) {
		let activeTab = el.querySelector('.slick-active')
		let button = document.createElement('button')
		let span = document.createElement('span')
		span.innerText = activeTab.innerText
		span.classList.add('slider-button-content')
		button.prepend(span)
		button.classList.add('slider-button', 'mt-3', 'mb-5')
		el.before(button)
	})

	// Button open and close menu functionality
	const toggleButtons = document.querySelectorAll('.slider-button')

	function removeOpen() {
		menus.forEach(function (el, idx) {
			if (el.classList.contains('open')) {
				// remove open from slick dots (menu window)
				el.classList.remove('open')
				// remove open from button
				toggleButtons[idx].classList.remove('open')
			}
		})
	}

	toggleButtons.forEach(function (el, idx) {
		el.addEventListener('click', function () {
			if (menus[idx].classList.contains('open')) {
				removeOpen()
			} else {
				menus[idx].classList.add('open')
				el.classList.add('open')
			}
		})
	})

	// Slide selector functionality
	const tabs = document.querySelectorAll('.slick-dots li')
	tabs.forEach(function (el) {
		el.addEventListener('click', function () {
			removeOpen()
			// Update button copy to current slide
			el.parentElement.previousElementSibling.childNodes[0].innerText =
				el.innerText
		})
	})
}

function animateBodyUniqueContent() {
	const section = document.querySelector('.body-content--section')
	if (!section) {
		return
	}

	const headings = section.querySelectorAll('h2')
	const content = section.querySelectorAll('p')
	const btn = section.querySelectorAll('.btn')
	gsap.set(headings, { opacity: 0 })
	gsap.set(content, { opacity: 0 })
	gsap.set(btn, { opacity: 0 })
	gsap.set('.body-secondary--img', { y: -125 })

	gsap
		.timeline({ defaults: { opacity: 1, y: 0, stagger: 0.1, duration: 0.2 } })
		.to(headings, {})
		.to(content, {})
		.to(btn, {}, '-=.3')

	let mql = window.matchMedia('(max-width: 768px)')

	if (mql.matches) {
		let hasSlider = document.querySelector('.theme-partner-carousel--wrap')
		if (hasSlider) {
			gsap.set('.body-primary--img', { y: 25 })
			gsap.to('.body-primary--img', {
				y: -100,
				ease: 'none',
				scrollTrigger: {
					trigger: '.body-primary--img',
					scrub: 2,
				},
			})
		}
	} else {
		gsap.set('.body-primary--img', { y: '5%' })
		gsap.to('.body-primary--img', {
			y: '25%',
			ease: 'none',
			scrollTrigger: {
				trigger: '.body-primary--img',
				scrub: 0.1,
			},
		})
	}

	gsap.to('.body-secondary--img', {
		y: -200,
		ease: 'none',
		scrollTrigger: {
			trigger: '.body-secondary--img',
			scrub: 3,
		},
	})
}

function animateBodyContent() {
	const section = document.querySelector('.theme-body--sections')
	if (!section) {
		return
	}

	const headings = section.querySelectorAll('h2')
	const content = section.querySelectorAll('p')
	const images = section.querySelectorAll('img:not(.desktop-image--primary)')
	const btn = section.querySelectorAll('.btn')
	gsap.set(headings, { opacity: 0 })
	gsap.set(content, { opacity: 0 })
	// gsap.set(images, { y: 16, opacity: 0 })

	if (!btn) {
		gsap
			.timeline({
				defaults: { opacity: 1, y: 0, stagger: 0.1, duration: 0.2 },
			})
			.to(headings, {})
			.to(content, {})
		// .to(images, {}, '-=.3')
	} else {
		gsap.set(btn, { opacity: 0 })

		gsap
			.timeline({
				defaults: { opacity: 1, y: 0, stagger: 0.1, duration: 0.2 },
			})
			.to(headings, {})
			.to(content, {})
			.to(btn, {})
		// .to(images, {}, '-=.2')

		const primeImg = document.querySelector('.desktop-image--primary')
		const secImg = document.querySelector('.secondary-image')

		let mql = window.matchMedia('(max-width: 768px)')

		if (mql.matches) {
			let hasSlider = document.querySelector('.theme-partner-carousel--wrap')
			if (hasSlider) {
				gsap.set(primeImg, { y: -10 })
				gsap.to(primeImg, {
					y: 25,
					ease: 'none',
					scrollTrigger: {
						trigger: primeImg,
						// start: "top bottom", // the default values
						// end: "bottom top",
						scrub: 1,
					},
				})
			}
		} else {
			gsap.set(primeImg, { y: 0 })
			gsap.to(primeImg, {
				y: 100,
				ease: 'none',
				scrollTrigger: {
					trigger: primeImg,
					// start: "top bottom", // the default values
					// end: "bottom top",
					scrub: 1,
				},
			})
		}

		if (secImg) {
			gsap.set(secImg, { y: -25 })
			gsap.to(secImg, {
				y: 75,
				ease: 'none',
				scrollTrigger: {
					trigger: secImg,
					// start: "top bottom", // the default values
					// end: "bottom top",
					scrub: 3,
				},
			})
		}
	}
}

function animateBasicLinks() {
	const sections = gsap.utils.toArray('.theme-cards--section')
	if (!sections) {
		return
	}

	sections.forEach((section) => {
		const cards = section.querySelectorAll('.theme--card')
		const heading = section.querySelector('h2')
		gsap.set(cards, { opacity: 0, y: -16 })
		gsap.set(heading, { opacity: 0 })
		gsap
			.timeline({
				scrollTrigger: { trigger: section, start: 'top 95%' },
				defaults: { opacity: 1, y: 0, stagger: 0.1, duration: 0.2 },
			})
			.to(heading, {})
			.to(cards, {})
	})
}

function animateContentColumns() {
	const sections = gsap.utils.toArray('.theme-columns--section')
	if (!sections) {
		return
	}

	sections.forEach((section) => {
		const heading = section.querySelector('h2')
		const columns = section.querySelectorAll('.theme-columns--column')

		gsap.set(heading, { opacity: 0 })
		gsap.set(columns, { opacity: 0, y: -16 })

		gsap
			.timeline({
				scrollTrigger: { trigger: section, start: 'top 95%' },
				defaults: { opacity: 1, y: 0, stagger: 0.1, duration: 0.2 },
			})
			.to(heading, {})
			.to(columns, {})
	})
}

function animateRedContentBlock() {
	const sections = gsap.utils.toArray('.theme-red-block--section')
	if (!sections) {
		return
	}

	sections.forEach((section) => {
		const link = section.querySelector('.red-block-link')
			? section.querySelector('.red-block-link')
			: section.querySelector('.card-padding')

		// const block = section.querySelector('.card-padding')
		gsap.set(link, { opacity: 0.5, y: 16 })

		gsap.to(link, {
			scrollTrigger: { trigger: section, start: 'top 95%' },
			opacity: 1,
			y: 0,
			duration: 0.2,
		})
	})
}

function animateBoxGrid() {
	const sections = gsap.utils.toArray('.theme-box-grid--section')
	if (!sections) {
		return
	}

	sections.forEach((section) => {
		const main = section.querySelector('.theme-box-grid--left')
		const secondary = section.querySelector('.theme-box-grid--right')
		const linkSub = secondary.querySelector('.theme-box-secondary--link')
		const linkSub02 = secondary.querySelector('.theme-grid-sub--link')

		const pre = main.querySelector('.pre-heading')
		const header = main.querySelector('h2')
		const content = main.querySelector('.box-grid--content')
		const btn = main.querySelector('.btn')

		gsap.set([pre, header, content, btn], { opacity: 0, y: 16 })
		gsap.set([linkSub, linkSub02], { opacity: 0 })

		gsap
			.timeline({
				scrollTrigger: { trigger: section, start: 'top 95%' },
				defaults: { opacity: 1, y: 0, duration: 0.2 },
			})
			.to(pre, {})
			.to(header, {}, '-=.2')
			.to(content, {}, '-=.1')
			.to(btn, {}, '-=.1')
			.to(linkSub, {}, '-=.1')
			.to(linkSub02, {}, '-=.2')
	})
}

function animatePartnershipGrid() {
	let portfolioImg = document.querySelectorAll('.theme-partnerships--grid img')

	if (!portfolioImg || !portfolioImg.length) {
		return
	}
	// console.log(portfolioImg)
	gsap.from(portfolioImg, {
		scrollTrigger: {
			trigger: portfolioImg,
			start: 'top 90%',
		},
		y: -20,
		opacity: 0,
		stagger: 0.1,
		duration: 0.3,
	})
}

function toggleGridModal() {
	const gridItems = document.querySelectorAll('.theme-grid-modal--item')
	const modals = document.querySelectorAll('.theme-grid-modal--overlay')
	const closeBtns = document.querySelectorAll('.close-button')

	function closeModals() {
		modals.forEach((modal, index) => {
			if (modal.classList.contains('closed')) {
				return
			}
			modal.classList.add('closed')
			modal.ariaHidden = true
			gridItems[index].dataset.view = 'closed'
		})
	}

	document.addEventListener('keyup', (e) => {
		if (e.key === 'Escape') {
			closeModals()
		}
	})

	closeBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			closeModals()
		})
	})

	$('.theme-grid-modal--overlay').on('click', function (e) {
		e.stopPropagation()
		if (
			e.target.classList.contains('theme-grid-modal--overlay') ||
			e.target.classList.contains('theme-mh')
		) {
			closeModals()
		}
	})

	gridItems.forEach((item, index) => {
		item.addEventListener('click', () => {
			if (item.dataset.view == 'closed') {
				// console.log(index)
				item.dataset.view = 'open'
				// modals[index].classList.remove('closed')
				// modals[index].ariaHidden = false
				const modal = document.querySelector(
					`.theme-grid-modal--overlay[data-idx="${index}"]`
				)
				// console.log(modal)
				if (!modal) return
				modal.classList.remove('closed')
				modal.ariaHidden = false
			}
		})
	})
}

function partnerCarousel() {
	let hasSlider = document.querySelector('.theme-partner-carousel--wrap')
	if (!hasSlider) {
		return
	}
	$('.theme-partner-carousel--wrap').slick({
		dots: false,
		arrows: true,
		prevArrow: $('.theme-partner--prev'),
		nextArrow: $('.theme-partner--next'),
		slidesToShow: Math.min(
			5,
			Math.max($('.theme-partner-carousel--single').length, 3)
		),
		slidesToScroll: Math.min(
			5,
			Math.max($('.theme-partner-carousel--single').length, 3)
		),
		autoplay: false,
		speed: 300,
		cssEase: 'ease-out',
		// centerMode: true,
		infinite: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					// dots: true,
					// centerMode: true,
					// centerPadding: '60px',
				},
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$('.theme-partner-carousel--section').css('display', 'block')
}

function turnToAccordion() {
	let sets = document.getElementsByClassName('theme-document--set')
	if (!sets || sets.length < 2) {
		return
	}
	console.log(sets.length)
	for (let set of sets) {
		let btn = set.querySelector('.accordion')
		let documents = set.querySelector('.theme-document--wrap')
		btn.addEventListener('click', () => {
			// console.log(set)
			btn.classList.toggle('active')
			documents.classList.toggle('mobile-active')
		})
	}
}

function openAccordions() {
	let sets = document.getElementsByClassName('theme-document--set')
	if (!sets) {
		return
	}
	for (let set of sets) {
		let btn = set.querySelector('.accordion')
		let documents = set.querySelector('.theme-document--wrap')
		btn.classList.remove('active')
		documents.classList.remove('mobile-active')
	}
}

const handleAccordion = () => {
	let newQuery = window.matchMedia(' ( max-width: 767px ) ')
	const queryListenChanges = (query) => {
		if (query.matches) {
			turnToAccordion()
		} else {
			openAccordions()
		}
	}
	newQuery.addListener(queryListenChanges)
	queryListenChanges(newQuery)
}

const handleAccordionCard = () => {
	const accordions = document.querySelectorAll('.accordion-button')
	const accordionsBody = document.querySelectorAll('.accordion-content')
	const accordionsImg = document.querySelectorAll('.accordion-card--img')
	const accordionContent = document.querySelector('.accordion-card--left')

	if (!accordions) {
		return
	}

	accordions.forEach((accordion, index) => {
		accordion.addEventListener('click', function (e) {
			if (accordion.getAttribute('aria-expanded') == 'true') {
				return
			}
			// button updates
			accordions.forEach((el) => {
				el.setAttribute('aria-expanded', 'false')
			})
			accordion.setAttribute('aria-expanded', 'true')

			// content updates
			accordionsBody.forEach((el, idx) => {
				el.classList.add('closed')
				el.classList.remove('opened')
				if (index == idx) {
					el.classList.remove('closed')
					el.classList.add('opened')
				}
			})

			// img updates
			accordionsImg.forEach((el, idx) => {
				if (index == idx) {
					el.classList.add('current')
					el.classList.contains('left')
						? accordionContent.classList.add('reversed')
						: accordionContent.classList.remove('reversed')
				} else {
					el.classList.remove('current')
				}
			})
		})
	})
	// for (let [index, accordion] of accordions.entries()) {
	// }
}

const handleFAQs = () => {
	const details = document.querySelectorAll('.faqs .details')
	if ( ! details ) { return }

	details.forEach((detail) => {
		detail.addEventListener('click', (  ) => {
			detail.classList.toggle('details-open')

			// Close all other details elements
			// console.log(document.querySelectorAll('.details-open'))
			document.querySelectorAll('.details-open').forEach((otherDetail) => {
				if ( otherDetail !== detail ){
					otherDetail.classList.remove('details-open')
				}
			})
			
		})
	})
}
